import React from 'react';
import {CSSTransition} from 'react-transition-group';
import {PropTypes} from 'prop-types';
import {ButtonIcon} from '@homeaway/react-buttons';
import {CLOSE__24} from '@homeaway/svg-defs';
import OnboardingButtons from '../OnboardingGuideModals/OnboardingButtons.react';
import './OnboardingGuideModal.less';
// eslint-disable-next-line no-lone-blocks
{
    /* images*/
}
import OnboardingOval from './oval_icon.svg';

class OnboardingGuideModal extends React.Component {
    static propTypes = {
        onDone: PropTypes.func.isRequired,
        onNext: PropTypes.func,
        text: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired,
        page: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        iconAnimationClass: PropTypes.string.isRequired,
        next: PropTypes.string,
        done: PropTypes.string.isRequired,
        transition: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this._handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._handleClickOutside);
    }

    _onClickDone = (buttonClicked, buttonName) => {
        this.props.onDone(buttonClicked, buttonName);
    };

    _onClickNext = (buttonClicked, buttonName) => {
        if (this.props.onNext) {
            this.props.onNext(buttonClicked, buttonName);
        }
    };

    _handleClickOutside = (event) => {
        if (!this.myRef.current.contains(event.target)) {
            if (this.props.next) {
                this._onClickNext(false, null);
            } else if (this.props.done) {
                this._onClickDone(false, null);
            }
        }
    };

    render() {
        const props = this.props;
        let hasNext = !!props.next;

        return (
            <CSSTransition classNames={props.transition} timeout={1500} in appear>
                <div className="OnboardingGuide" ref={this.myRef}>
                    <ButtonIcon
                        className="OnboardingXButton"
                        label="Default Button"
                        svgMarkup={CLOSE__24}
                        inverse
                        noBorder
                        circle
                        onClick={() => this._onClickDone(true, 'X')}
                    />
                    <div className="OnboardingPageNumber">{props.page}</div>
                    <div className="OnboardingText">{props.text}</div>
                    <div className={props.iconAnimationClass}>
                        <img src={props.icon} />
                    </div>
                    <div className="OnboardingOval">
                        <img src={OnboardingOval} />
                    </div>
                    <OnboardingButtons
                        primaryText={hasNext ? props.next : props.done}
                        secondaryText={hasNext ? props.done : null}
                        onPrimary={hasNext ? this._onClickNext : this._onClickDone}
                        onSecondary={hasNext ? this._onClickDone : null}
                    />
                </div>
            </CSSTransition>
        );
    }
}

export default OnboardingGuideModal;
